import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import { UrlHyperlinkContainerModel } from "../../../../../../../models";

@Injectable({providedIn: "root"})
export class UrlHyperlinkService extends BaseApiTemplateService<UrlHyperlinkContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'url-hyperlinks';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX +  'url-hyperlinks';
    this.httpClient = http;
  }
}
